// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"39697797","796":"cd3b4fd3"}[chunkId] + ".chunk.js";
};